import { render, staticRenderFns } from "./PcPageTitle.vue?vue&type=template&id=57329999&scoped=true"
import script from "./PcPageTitle.vue.js?vue&type=script&lang=js&external"
export * from "./PcPageTitle.vue.js?vue&type=script&lang=js&external"
import style0 from "./PcPageTitle.vue?vue&type=style&index=0&id=57329999&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57329999",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
